module.exports = __webpack_public_path__ + "img/notice.f5a88517.svg";